/* L&P bundle picker — Hebrew / RTL.
   Two tiers (1+1, 2+2). Each slot picks a MODEL, then a COLOR (variant).
   Prices mirror Shopify's automatic BxGy: the cheapest units in the bundle are the free ones.
   DAVID mode (2026-09-14, "mode":"david" + "anchor" in the data JSON): one 1+1 card, slot #1
   locked to the page's own David / nano-chip watch (colour still selectable), slot #2 browses
   the gift pool only. The anchor is always the paid unit — that mirrors the scoped discount. */
(function () {
  "use strict";

  var root = document.getElementById("lpb-root");
  /* Arabic store (/ar): same widget, Arabic strings. Hebrew stays the default branch. */
  var AR = document.documentElement.lang === "ar";
  function T(he, ar) { return AR ? ar : he; }
  if (AR && root) root.setAttribute("lang", "ar");
  var dataNode = document.getElementById("lpb-data");
  if (!root || !dataNode || root.getAttribute("data-ready")) return;

  var data;
  try { data = JSON.parse(dataNode.textContent); } catch (e) { return; }
  if (!data.products || !data.products.length) return;

  /* ---------- out of the offer entirely (2026-09-17, Adam) ----------
     Blocked on cost AND priced below the priciest gift. Leaving them on the discount's BUYS side
     made Shopify free the PRICIER watch: it frees the cheapest item it can take from the GETS
     collection, and once the cheap-but-costly watch is out of GETS the only candidate left is
     the dearer one. So they are out of BOTH sides and no bundle can fire on them. Their own page
     renders no widget (the native Add to cart stays), and they never appear in anyone's picker.
     REGENERATE with patch_js.py; it derives this list from the buys collection on Shopify. */
  var OUT_OF_OFFER = {
    "six-case-women": 1
  };

  if (OUT_OF_OFFER[data.current] && data.mode !== "david") return;

  /* A multi-watch case (מארז) is emitted into the pool by the block liquid, whose only filter
     is "title contains צמיד". It is not a watch and must never be a bundle slot or a gift, at
     any price — do not leave that to it happening to sit in OUT_OF_OFFER today. */
  var NOT_A_WATCH = /מארז|Collector Case/;

  var products = data.products.filter(function (p) {
    return p.c && p.c.length && !OUT_OF_OFFER[p.h] && !NOT_A_WATCH.test(p.t);
  });
  /* Arabic store: the David line is not offered at all (Adam, H5). Hebrew unaffected. */
  var AR_HIDE = {
    "la-poedagar™": 1,
    "la-poedagar™-tree-of-life-copy": 1,
    "la-poedagar™-עם-כלביא": 1,
    "la-poedagar™-עם-ישראל-חי": 1,
    "la-poedagar™-for-the-idf": 1,
    "la-poedagar™-jerusalem": 1,
    "la-poedagar™-jerusalem-1": 1,
    "la-poedagar™-jerusalem-2": 1,
    "la-poedagar™-the-decalogue": 1,
    "l-p™-psalm-of-david": 1,
    "l-p™-sinai": 1,
    "l-p™-ascent": 1,
    "l-p™-priestly-blessing": 1,
    "l-p-hageola": 1,
    "la-poedagar™-אדוני-אחד": 1,
    "lp-rabbi-nachman-black": 1,
    "lp-rabbi-nachman-green": 1,
    "l-p-or-olam-nano-tanach-chip": 1,
    "l-p-sefer-hasfarim-nano-tanach-chip": 1
  };
  if (AR) products = products.filter(function (p) { return !AR_HIDE[p.h]; });
  if (!products.length) return;

  /* collections.all has no meaningful order, so restore the order of the 1+1 pool. */
  var order = String(data.order || "").split(",");
  products.sort(function (a, b) {
    var ai = order.indexOf(a.h), bi = order.indexOf(b.h);
    return (ai < 0 ? order.length : ai) - (bi < 0 ? order.length : bi);
  });

  var byHandle = {};
  for (var i = 0; i < products.length; i++) byHandle[products[i].h] = products[i];

  /* David mode: the page's own watch is the ANCHOR — registered by handle so every helper can
     resolve it, but never pushed into `products`, so it can never show up as a gift. */
  var anchor = null;
  if (data.mode === "david" && data.anchor && data.anchor.c && data.anchor.c.length) {
    anchor = data.anchor;
    byHandle[anchor.h] = anchor;
  }
  var start = anchor || byHandle[data.current] || products[0];

  /* Several products share one name (three "L&P™ Jerusalem", one per colour). For those the
     colour is the only thing that tells them apart, so it is shown under the name everywhere
     (Adam, 2026-10-27). Unique names keep the old "אין עוד צבע" behaviour. */
  var titleCount = {};
  (function () {
    var seen = {}, all = products.concat(anchor ? [anchor] : []);
    for (var n = 0; n < all.length; n++) {
      if (seen[all[n].h]) continue;
      seen[all[n].h] = 1;
      var key = String(all[n].t || "").trim().toLowerCase();
      titleCount[key] = (titleCount[key] || 0) + 1;
    }
  })();
  function sharesTitle(product) {
    return (titleCount[String(product.t || "").trim().toLowerCase()] || 0) > 1;
  }

  /* Men's + women's models share one rail; a picker only ever browses one gender at a time.
     "m"/"w" come from the block liquid. Order fixed here (not by JSON encounter order) so the
     tabs are never in a surprising order if the data ever changes shape. */
  var GENDER_ORDER = ["m", "w"];
  var GENDER_LABEL = { m: T("קולקציית גברים", "مجموعة الرجال"), w: T("קולקציית נשים", "مجموعة النساء") };
  var genders = [];
  for (i = 0; i < GENDER_ORDER.length; i++) {
    for (var gi = 0; gi < products.length; gi++) {
      if (products[gi].g === GENDER_ORDER[i]) { genders.push(GENDER_ORDER[i]); break; }
    }
  }
  var pickerGender = (genders.indexOf(start.g) > -1 ? start.g : genders[0]) || "m";

  /* ---------- cost gate (2026-09-17, Adam) ----------
     A watch whose unit cost is over 90 ₪ can be PAID for inside a bundle but can never be the
     free unit: it is not in the Shopify gift-pool collection that the BxGy "gets" side points
     at. So a bundle has to hold at least giftCount giftable watches or the discount does not
     fire AT ALL — hence the picker hides non-giftable models once the remaining slots are the
     only thing keeping the offer alive, and priceFor stops pretending.
     REGENERATE this list with patch_js.py whenever the gift pool changes; verify.py asserts it
     still matches Shopify. */
  var NO_GIFT = {
    "l-p™-collector-case": 1,
    "la-poedagar™": 1,
    "la-poedagar™-caesarea": 1,
    "la-poedagar™-for-the-idf": 1,
    "la-poedagar™-jerusalem": 1,
    "la-poedagar™-jerusalem-1": 1,
    "la-poedagar™-jerusalem-2": 1,
    "la-poedagar™-the-decalogue": 1,
    "la-poedagar™-tree-of-life-copy": 1,
    "la-poedagar™-עם-ישראל-חי": 1,
    "la-poedagar™-עם-כלביא": 1,
    "lp-rabbi-nachman-black": 1,
    "lp-rabbi-nachman-green": 1,
    "six-case-women": 1
  };

  function isGiftable(product) { return !!product && !NO_GIFT[product.h]; }
  function giftCount(tier) { return tier.slots - tier.payFor; }

  /* how many giftable watches the tier would still hold if slotIndex were emptied */
  function giftableIn(tierIndex, slotIndex) {
    var n, c = 0;
    for (n = 0; n < picks[tierIndex].length; n++) {
      if (n === slotIndex) continue;
      if (isGiftable(byHandle[picks[tierIndex][n].h])) c++;
    }
    return c;
  }

  function poolFor(gender, tierIndex, slotIndex) {
    var out = [];
    var gate = tierIndex != null &&
      giftableIn(tierIndex, slotIndex) < giftCount(tiers[tierIndex]);
    for (var n = 0; n < products.length; n++) {
      if (products[n].g !== gender) continue;
      if (gate && !isGiftable(products[n])) continue;
      out.push(products[n]);
    }
    return out;
  }

  var tiers = [
    { id: "b1g1", slots: 2, payFor: 1, title: T("קנה 1 קבל 1 מתנה", "اشتري ساعة والتانية علينا هدية"), subtitle: "" },
    { id: "b2g2", slots: 4, payFor: 2, title: T("קנה 2 קבל 2 מתנה", "اشتري ساعتين والتنتين التانيات علينا هدية"), subtitle: T("המשתלם ביותר", "الأوفر"), flag: T("מבצע סתיו", "") }
  ];
  /* David mode is a single 1+1 card (Adam, 2026-09-14: no 2+2 on David). Its subtitle spells
     out the mechanic instead of carrying the regular widget's countdown line — that line is not
     true and Adam asked for it gone here. */
  if (anchor) {
    tiers = [{
      id: "b1g1", slots: 2, payFor: 1,
      title: T("קנה 1 קבל 1 מתנה", "اشتري ساعة والتانية علينا هدية"),
      subtitle: T("שעון דוד אחד + שעון מהקולקציה הרגילה במתנה", "ساعة + ساعة تانية من التشكيلة العادية هدية")
    }];
  }

  var selectedTier = 0;
  var openPicker = null;
  var busy = false;
  var picks = [];
  var defaultGift = anchor ? products[0] : start;
  for (i = 0; i < tiers.length; i++) {
    picks.push([]);
    for (var j = 0; j < tiers[i].slots; j++) {
      var seed = (anchor && j > 0) ? defaultGift : start;
      picks[i].push({ h: seed.h, id: seed.c[0].id });
    }
  }

  /* A page whose own watch is not giftable would otherwise open with that watch in every
     slot — a bundle the discount cannot fire on, showing a saving the cart would refuse. Seed
     the surplus slots with the first giftable model instead. Slot #1 always keeps the page's
     own watch: it is the one the shopper came for, and it is the paid unit. */
  (function seedGiftableDefaults() {
    var firstGiftable = null, n, t;
    for (n = 0; n < products.length; n++) {
      if (isGiftable(products[n])) { firstGiftable = products[n]; break; }
    }
    if (!firstGiftable) return;
    for (t = 0; t < tiers.length; t++) {
      for (n = picks[t].length - 1; n >= 1; n--) {
        if (giftableIn(t, -1) >= giftCount(tiers[t])) break;
        if (isGiftable(byHandle[picks[t][n].h])) continue;
        picks[t][n] = { h: firstGiftable.h, id: firstGiftable.c[0].id };
      }
    }
  })();

  /* ---------- helpers ---------- */

  function escapeHTML(v) {
    return String(v).replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function money(cents) { return (Math.round(cents) / 100).toFixed(2) + " ₪"; }

  function colorOf(pick) {
    var product = byHandle[pick.h];
    for (var n = 0; n < product.c.length; n++) if (product.c[n].id === pick.id) return product.c[n];
    return product.c[0];
  }

  function colorName(product, color) {
    var name = String(color.n || "");
    if (!name || name === "Default Title" || name === "Title") return "";
    /* Some variants are named "<model> - <colour>" ("Legacy - ירוק אמרלד"); drop that prefix.
       Others are genuinely two colours ("כסף - כחול" on Dubai = silver case, blue dial) and
       must be kept whole — splitting on " - " blindly threw half the colour away. */
    var cut = name.indexOf(" - ");
    if (cut > -1) {
      var prefix = name.slice(0, cut).trim().toLowerCase();
      var model = String(product.t || "").replace(/^L&P.*?\s/i, "").trim().toLowerCase();
      if (prefix && model && (prefix === model || model.indexOf(prefix) > -1)) {
        name = name.slice(cut + 3).trim();
      }
    }
    return name;
  }

  /* What the slot row shows under the model name. The swatches stay unprefixed.
     A single-colour model has nothing to choose, so "צבע: X" (Adam, 2026-09-11: pointless,
     wastes space) is replaced with a plain "זמין" — no colour picker is offered for these
     either, see colorStrip()'s length check below. */
  function colorLabel(product, color) {
    if (sharesTitle(product)) {
      var own = colorName(product, color);
      if (own) return T("צבע: ", "اللون: ") + own;
    }
    if (product.c.length < 2) return T("אין עוד צבע", "ما في لون تاني");
    var name = colorName(product, color);
    return name ? T("צבע: ", "اللون: ") + name : "";
  }

  function colorById(product, id) {
    for (var n = 0; n < product.c.length; n++) if (product.c[n].id === id) return product.c[n];
    return product.c[0];
  }

  function lowestPrice(product) {
    var low = product.c[0];
    for (var n = 1; n < product.c.length; n++) if (product.c[n].p < low.p) low = product.c[n];
    return low;
  }

  function priceFor(tierIndex) {
    var tier = tiers[tierIndex], values = [], was = 0;
    for (var n = 0; n < picks[tierIndex].length; n++) {
      var price = colorOf(picks[tierIndex][n]).p;
      values.push(price); was += price;
    }
    /* David mode mirrors the scoped discount (buys: davidwatches, gets: gift pool): the anchor
       is the paid unit whatever the gift costs, so it is never "cheapest free" arithmetic. */
    if (anchor) {
      var anchorPaid = 0;
      for (var a = 0; a < picks[tierIndex].length; a++) {
        if (picks[tierIndex][a].h === anchor.h) anchorPaid += colorOf(picks[tierIndex][a]).p;
      }
      return { now: anchorPaid, was: was };
    }
    /* Shopify frees the cheapest units it can take from the GETS collection, so only
       giftable watches can ever come off the bill — and if the bundle holds fewer than
       giftCount of them the BxGy does not fire and the shopper pays for everything. */
    var giftable = [];
    for (var g2 = 0; g2 < picks[tierIndex].length; g2++) {
      if (isGiftable(byHandle[picks[tierIndex][g2].h])) {
        giftable.push(colorOf(picks[tierIndex][g2]).p);
      }
    }
    var need = giftCount(tier);
    if (giftable.length < need) return { now: was, was: was };
    giftable.sort(function (a, b) { return a - b; });
    var free = 0;
    for (var k = 0; k < need; k++) free += giftable[k];
    return { now: was - free, was: was };
  }

  function image(url, className) {
    return url
      ? '<img class="' + className + '" src="' + escapeHTML(url) + '" alt="" loading="lazy" width="120" height="120">'
      : '<span class="' + className + ' is-empty" aria-hidden="true"></span>';
  }

  /* Swaps an <img> src without the hard cut a plain assignment gives — dip the opacity, assign
     the new src directly (no separate preload probe: that doubled every swap into two parallel
     fetches of the same image, 2026-09-11), then recover once the REAL img's own load/error
     fires. Paired with the `transition: opacity` on every thumb/model/swatch image in the CSS.
     Doing nothing when the src is unchanged (the common case on a re-render) avoids a needless
     flicker. */
  function swapImage(img, src) {
    if (!img || !src) return;
    if (img.getAttribute("src") === src) { img.style.opacity = ""; return; }
    img.style.opacity = "0.35";
    var done = function () { img.style.opacity = ""; };
    img.onload = done;
    img.onerror = done;
    img.src = src;
  }

  /* RTL rails are a minefield: scrollLeft runs 0 -> negative in Chromium, 0 -> positive
     elsewhere, and scroll-snap re-snaps after any programmatic scroll. Measuring the sign once
     at render time was unreliable (the rail is not yet scrollable while its images load), so
     nothing here depends on knowing it: distance is always read as an absolute, movement is
     always relative, and the one absolute setter corrects itself. */
  function railPos(rail) { return Math.abs(rail.scrollLeft); }

  function setRailPos(rail, pos) {
    rail.scrollLeft = -pos;
    if (railPos(rail) < pos - 2) rail.scrollLeft = pos;
  }

  function smooth() {
    return (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      ? "auto" : "smooth";
  }

  /* ---------- markup ---------- */

  function modelCard(product, chosenHandle, chosenId, tierIndex, slotIndex) {
    var active = product.h === chosenHandle;
    /* the selected card mirrors the chosen colour — image and price — so the big card and the
       swatch row can never disagree (the bug Adam hit on 2026-09-11). */
    var low = active ? colorById(product, chosenId) : lowestPrice(product);
    var art = active ? (low.img || product.img) : product.img;
    return '<button type="button" class="lpb__model' + (active ? " is-selected" : "") + '"' +
      ' data-tier="' + tierIndex + '" data-slot="' + slotIndex + '"' +
      ' data-model="' + escapeHTML(product.h) + '"' +
      ' aria-pressed="' + (active ? "true" : "false") + '"' +
      ' aria-label="' + T('בחר ', 'اختار ') + escapeHTML(product.t) + '">' +
      '<span class="lpb__check" aria-hidden="true">&#10003;</span>' +
      image(art, "lpb__model-image") +
      '<span class="lpb__model-name">' + escapeHTML(product.t) + '</span>' +
      (sharesTitle(product) && colorName(product, low)
        ? '<span class="lpb__model-color">' + escapeHTML(colorName(product, low)) + '</span>' : '') +
      '<span class="lpb__model-price"><span>' + money(low.p) + '</span>' +
      (low.cp > low.p ? '<s class="lpb__model-was">' + money(low.cp) + '</s>' : '') +
      '</span></button>';
  }

  function colorStrip(product, chosenId, tierIndex, slotIndex) {
    if (product.c.length < 2) return "";
    var html = '<div class="lpb__colors"><p class="lpb__colors-title">' + T('בחר צבע', 'اختار اللون') + '</p><div class="lpb__swatches">';
    for (var n = 0; n < product.c.length; n++) {
      var color = product.c[n], on = color.id === chosenId;
      html += '<button type="button" class="lpb__swatch' + (on ? " is-selected" : "") + '"' +
        ' data-tier="' + tierIndex + '" data-slot="' + slotIndex + '"' +
        ' data-color="' + color.id + '" data-model="' + escapeHTML(product.h) + '"' +
        ' aria-pressed="' + (on ? "true" : "false") + '"' +
        ' aria-label="' + escapeHTML(colorName(product, color) || product.t) + '">' +
        image(color.img, "lpb__swatch-image") +
        '<span class="lpb__swatch-name">' + escapeHTML(colorName(product, color)) + '</span>' +
        '</button>';
    }
    return html + '</div></div>';
  }

  function genderTabs(tierIndex, slotIndex) {
    if (genders.length < 2) return "";
    var html = '<div class="lpb__gender" role="tablist" aria-label="' + T('קטגוריה', 'الفئة') + '">';
    for (var n = 0; n < genders.length; n++) {
      var g = genders[n], on = g === pickerGender;
      html += '<button type="button" class="lpb__gender-btn' + (on ? " is-on" : "") + '"' +
        ' data-gender="' + g + '" data-tier="' + tierIndex + '" data-slot="' + slotIndex + '"' +
        ' role="tab" aria-selected="' + (on ? "true" : "false") + '">' +
        escapeHTML(GENDER_LABEL[g] || g) + '</button>';
    }
    return html + '</div>';
  }

  function picker(tierIndex, slotIndex) {
    var pick = picks[tierIndex][slotIndex];
    var product = byHandle[pick.h];
    var pool = poolFor(pickerGender, tierIndex, slotIndex);
    var title = anchor ? T("בחר את שעון המתנה שלך", "اختار ساعة الهدية تبعتك") : T("בחר דגם", "اختار موديل");
    var note = anchor
      ? '<p class="lpb__picker-note">' + T('מתוך הקולקציה הרגילה של L&amp;P, גברים ונשים. לא שעון דוד נוסף.', 'من تشكيلة L&amp;P العادية، رجالي ونسائي.') + '</p>'
      : '';
    var html = '<div class="lpb__picker" role="group" aria-label="' + T('בחירת שעון ', 'اختيار الساعة ') + (slotIndex + 1) + '">' +
      '<p class="lpb__picker-title">' + title + '</p>' + note +
      genderTabs(tierIndex, slotIndex) + '<div class="lpb__rail">';
    for (var n = 0; n < pool.length; n++) html += modelCard(pool[n], pick.h, pick.id, tierIndex, slotIndex);
    html += '</div><div class="lpb__pager">' +
      '<button type="button" class="lpb__page-arrow" data-page-step="1" aria-label="' + T('הקודם', 'السابق') + '">&#8250;</button>' +
      '<div class="lpb__progress" aria-hidden="true"><span class="lpb__progress-thumb"></span></div>' +
      '<button type="button" class="lpb__page-arrow" data-page-step="-1" aria-label="' + T('הבא', 'التالي') + '">&#8249;</button>' +
      '<span class="lpb__page-status" aria-live="polite"></span></div>' +
      colorStrip(product, pick.id, tierIndex, slotIndex) +
      '<button type="button" class="lpb__done" data-done="true">' + T('סיימתי', 'خلصت') + '</button></div>';
    return html;
  }

  /* David mode: slot #1 is the page's own watch. The model never changes; the row only opens a
     colour-only picker (no "בחר דגם", no rail, no gender tabs — Adam, 2026-09-14), and only
     when there is a colour to choose. A single-colour anchor renders as a static row. */
  /* On a regular page the watch IS in the pool, so `start` resolves from `products` and the lock
     simply pins slot #1 to it. If the current handle is somehow not in the pool, nothing locks and
     the widget behaves exactly as it did before. */
  var lockFirst = !!anchor || !!byHandle[data.current];
  function isLockedSlot(slotIndex) { return lockFirst && slotIndex === 0; }

  function lockedPicker(tierIndex, slotIndex) {
    var pick = picks[tierIndex][slotIndex];
    var product = byHandle[pick.h];
    return '<div class="lpb__picker lpb__picker--locked" role="group" aria-label="' + T('בחירת צבע לשעון ', 'اختيار لون للساعة ') + (slotIndex + 1) + '">' +
      colorStrip(product, pick.id, tierIndex, slotIndex) +
      '<button type="button" class="lpb__done" data-done="true">' + T('סיימתי', 'خلصت') + '</button></div>';
  }

  function slot(tierIndex, slotIndex) {
    var pick = picks[tierIndex][slotIndex];
    var product = byHandle[pick.h];
    var color = colorOf(pick);
    var name = colorLabel(product, color);
    var isOpen = openPicker && openPicker.tier === tierIndex && openPicker.slot === slotIndex;
    var locked = isLockedSlot(slotIndex);
    var fixed = locked && product.c.length < 2;
    var showFixedColor = fixed && sharesTitle(product) && !!name;
    var caption = anchor ? (slotIndex === 0 ? T("שעון דוד שבחרת", "الساعة اللي اخترتها") : T("המתנה שלך", "هديتك")) : "";
    var inner = '<span class="lpb__idx">#' + (slotIndex + 1) + '</span>' +
      image(color.img || product.img, "lpb__thumb") +
      '<span class="lpb__chosen-wrap">' +
      (caption ? '<span class="lpb__caption">' + caption + '</span>' : '') +
      '<span class="lpb__chosen">' + escapeHTML(product.t) + '</span>' +
      '<span class="lpb__color"' + (name && (!fixed || showFixedColor) ? '' : ' hidden') + '>' + escapeHTML(fixed && !showFixedColor ? '' : name) + '</span>' +
      '</span><span class="lpb__change' + (fixed ? ' lpb__change--fixed' : '') + '">' +
      (fixed ? T('השעון שלך', 'ساعتك') : (locked ? T('בחר צבע', 'اختار اللون') : T('שנה', 'غيّر'))) + '</span>';
    var html;
    if (fixed) {
      html = '<div class="lpb__slot is-locked is-fixed" data-tier="' + tierIndex + '" data-slot="' + slotIndex + '">' + inner + '</div>';
    } else {
      html = '<button type="button" class="lpb__slot' + (isOpen ? " is-open" : "") + (locked ? " is-locked" : "") + '"' +
        ' data-tier="' + tierIndex + '" data-slot="' + slotIndex + '" data-open-picker="true"' +
        ' aria-expanded="' + (isOpen ? "true" : "false") + '">' + inner + '</button>';
    }
    if (isOpen && !fixed) html += (locked ? lockedPicker : picker)(tierIndex, slotIndex);
    return html;
  }

  function card(tierIndex) {
    var tier = tiers[tierIndex];
    var active = selectedTier === tierIndex;
    var price = priceFor(tierIndex);
    var id = "lpb-" + tier.id;
    var html = '<div class="lpb__tier' + (active ? " is-on" : "") + '" data-tier-card="' + tierIndex + '">';
    if (tier.flag) html += '<span class="lpb__flag">' + tier.flag + '</span>';
    html += '<input class="lpb__radio" type="radio" name="lpb-tier" id="' + id + '" value="' + tierIndex + '"' +
      (active ? " checked" : "") + '>' +
      '<label class="lpb__head" for="' + id + '">' +
      '<span class="lpb__label"><span class="lpb__name">' + tier.title + '</span>' +
      (tier.subtitle ? '<span class="lpb__sub">' + tier.subtitle + '</span>' : '') + '</span>' +
      '<span class="lpb__money"><span class="lpb__now">' + money(price.now) + '</span>' +
      '<s class="lpb__was">' + money(price.was) + '</s></span></label>';
    if (active) {
      html += '<div class="lpb__slots" id="' + id + '-slots">';
      for (var n = 0; n < tier.slots; n++) html += slot(tierIndex, n);
      html += '</div>';
    }
    return html + '</div>';
  }

  /* ---------- render ---------- */

  function updatePrices() {
    for (var n = 0; n < tiers.length; n++) {
      var node = root.querySelector('[data-tier-card="' + n + '"]');
      if (!node) continue;
      var price = priceFor(n);
      node.querySelector(".lpb__now").textContent = money(price.now);
      node.querySelector(".lpb__was").textContent = money(price.was);
    }
    var sticky = infoScope.querySelector ? infoScope.querySelector("sticky-atc") : null;
    if (sticky) {
      var title = sticky.querySelector(".sticky-atc__title");
      if (title) title.textContent = T("החבילה שלך · ", "باقتك · ") + tiers[selectedTier].slots + T(" שעונים", " ساعات");
      var stickyPrice = sticky.querySelector(".sticky-atc__price");
      if (stickyPrice) stickyPrice.textContent = money(priceFor(selectedTier).now);
    }
  }

  function updatePager() {
    var rail = root.querySelector(".lpb__rail");
    if (!rail) return;
    var models = root.querySelectorAll(".lpb__model");
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var pos = Math.min(max, railPos(rail));
    var stride = models.length > 1 ? Math.abs(models[1].offsetLeft - models[0].offsetLeft) : rail.clientWidth;
    var active = Math.min(models.length - 1, Math.round(pos / (stride || 1)));
    root.querySelectorAll("[data-page-step]").forEach(function (button) {
      var step = Number(button.getAttribute("data-page-step"));
      button.disabled = busy || (step > 0 ? pos <= 1 : pos >= max - 1);
    });
    var track = root.querySelector(".lpb__progress");
    var thumb = root.querySelector(".lpb__progress-thumb");
    if (track && thumb) {
      var trackW = track.clientWidth;
      var thumbW = Math.max(18, Math.round(trackW * (rail.clientWidth / (rail.scrollWidth || 1))));
      thumb.style.width = thumbW + "px";
      thumb.style.right = (max > 0 ? Math.round((pos / max) * (trackW - thumbW)) : 0) + "px";
    }
    var status = root.querySelector(".lpb__page-status");
    if (status) status.textContent = T("דגם ", "موديل ") + (active + 1) + T(" מתוך ", " من ") + models.length;
  }

  function render(focusSelector) {
    var pageX = window.scrollX, pageY = window.scrollY;
    var cardsHTML = "";
    for (var ci = 0; ci < tiers.length; ci++) cardsHTML += card(ci);
    root.innerHTML =
      '<div class="lpb__rule"><span>' + T('מבצע לזמן מוגבל', 'عرض لفترة محدودة') + '</span></div>' +
      '<div class="lpb__tiers" role="radiogroup" aria-label="' + T('בחרו את החבילה', 'اختار الباقة') + '">' + cardsHTML + '</div>' +
      '<p class="lpb__error" role="alert" hidden></p>';
    root.classList.toggle("lpb--david", !!anchor);
    root.classList.toggle("is-busy", busy);
    root.setAttribute("aria-busy", busy ? "true" : "false");
    root.setAttribute("data-ready", "true");

    var rail = root.querySelector(".lpb__rail");
    if (rail) rail.addEventListener("scroll", updatePager, { passive: true });
    if (focusSelector) {
      var node = root.querySelector(focusSelector);
      if (node) {
        node.focus({ preventScroll: true });
        if (rail && node.classList.contains("lpb__model")) {
          var first = root.querySelector(".lpb__model");
          var offset = Math.abs(node.offsetLeft - first.offsetLeft);
          setRailPos(rail, Math.min(rail.scrollWidth - rail.clientWidth, offset));
        }
      }
    }
    window.scrollTo({ left: pageX, top: pageY, behavior: "instant" });
    updatePager();
    updatePrices();
  }

  /* ---------- events ---------- */

  function closest(target, selector) { return target && target.closest ? target.closest(selector) : null; }

  window.addEventListener("resize", updatePager, { passive: true });

  root.addEventListener("change", function (event) {
    if (busy || event.target.name !== "lpb-tier") return;
    selectedTier = Number(event.target.value);
    openPicker = null;
    render("#lpb-" + tiers[selectedTier].id);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !openPicker || busy) return;
    var tier = openPicker.tier, slotIndex = openPicker.slot;
    openPicker = null;
    event.preventDefault();
    render('[data-open-picker][data-tier="' + tier + '"][data-slot="' + slotIndex + '"]');
  });

  root.addEventListener("click", function (event) {
    if (busy) return;
    var target = event.target;

    var pageButton = closest(target, "[data-page-step]");
    if (pageButton) {
      var rail = root.querySelector(".lpb__rail");
      var models = root.querySelectorAll(".lpb__model");
      if (rail && models.length > 1) {
        var stride = Math.abs(models[1].offsetLeft - models[0].offsetLeft);
        /* data-page-step 1 is "previous" (toward the start, physically right in rtl). */
        var step = Number(pageButton.getAttribute("data-page-step"));
        rail.scrollBy({ left: step > 0 ? stride : -stride, behavior: smooth() });
      }
      return;
    }

    var swatch = closest(target, "[data-color]");
    if (swatch) {
      var st = Number(swatch.getAttribute("data-tier")), ss = Number(swatch.getAttribute("data-slot"));
      picks[st][ss] = { h: swatch.getAttribute("data-model"), id: Number(swatch.getAttribute("data-color")) };
      root.querySelectorAll("[data-color]").forEach(function (node) {
        var on = Number(node.getAttribute("data-color")) === picks[st][ss].id;
        node.classList.toggle("is-selected", on);
        node.setAttribute("aria-pressed", String(on));
      });
      refreshSlot(st, ss);
      paintSelectedModelCard(picks[st][ss]);
      updatePrices();
      return;
    }

    var genderButton = closest(target, "[data-gender]");
    if (genderButton) {
      var gt = Number(genderButton.getAttribute("data-tier")), gs = Number(genderButton.getAttribute("data-slot"));
      switchGender(gt, gs, genderButton.getAttribute("data-gender"));
      return;
    }

    var modelButton = closest(target, "[data-model]");
    if (modelButton) {
      var mt = Number(modelButton.getAttribute("data-tier")), ms = Number(modelButton.getAttribute("data-slot"));
      selectModel(mt, ms, modelButton.getAttribute("data-model"));
      return;
    }

    if (closest(target, "[data-done]")) {
      var dt = openPicker.tier, ds = openPicker.slot;
      openPicker = null;
      render('[data-open-picker][data-tier="' + dt + '"][data-slot="' + ds + '"]');
      return;
    }

    var slotButton = closest(target, "[data-open-picker]");
    if (slotButton) {
      var nt = Number(slotButton.getAttribute("data-tier")), ns = Number(slotButton.getAttribute("data-slot"));
      selectedTier = nt;
      var opening = !(openPicker && openPicker.tier === nt && openPicker.slot === ns);
      openPicker = opening ? { tier: nt, slot: ns } : null;
      if (opening) {
        var openedProduct = byHandle[picks[nt][ns].h];
        if (openedProduct && genders.indexOf(openedProduct.g) > -1) pickerGender = openedProduct.g;
      }
      var focusOpen = isLockedSlot(ns)
        ? '[data-color="' + picks[nt][ns].id + '"][data-tier="' + nt + '"][data-slot="' + ns + '"]'
        : '[data-model="' + escapeHTML(picks[nt][ns].h) + '"][data-tier="' + nt + '"][data-slot="' + ns + '"]';
      render(openPicker ? focusOpen : '[data-open-picker][data-tier="' + nt + '"][data-slot="' + ns + '"]');
      return;
    }

    var cardNode = closest(target, "[data-tier-card]");
    if (cardNode && !closest(target, "input,label")) {
      selectedTier = Number(cardNode.getAttribute("data-tier-card"));
      openPicker = null;
      render();
    }
  });

  /* Repaint the selected model card in the rail to the chosen colour, in place, so the rail
     keeps its scroll position and the swatch keeps focus. */
  function paintSelectedModelCard(pick) {
    var card = root.querySelector('.lpb__model.is-selected[data-model="' + escapeHTML(pick.h) + '"]');
    if (!card) return;
    var product = byHandle[pick.h];
    var color = colorById(product, pick.id);
    var art = color.img || product.img;

    var slotNode = card.querySelector(".lpb__model-image");
    if (slotNode && art) {
      if (slotNode.tagName === "IMG") {
        swapImage(slotNode, art);
      } else {
        var img = document.createElement("img");
        img.className = "lpb__model-image";
        img.alt = "";
        img.loading = "lazy";
        slotNode.parentNode.replaceChild(img, slotNode);
        swapImage(img, art);
      }
    }
    var now = card.querySelector(".lpb__model-price > span");
    if (now) now.textContent = money(color.p);
    var was = card.querySelector(".lpb__model-was");
    if (was) {
      if (color.cp > color.p) { was.textContent = money(color.cp); was.hidden = false; }
      else { was.hidden = true; }
    }
  }

  /* Picking a different watch used to call the same full render() as opening the picker in the
     first place — every one of the 33 rail images torn down and rebuilt, which read as
     "everything jumps and reloads" (Adam, 2026-09-11). This patches only the four things that
     actually change: the selection state across the rail, the picked card's own art, the
     colour strip (the one thing that is genuinely different per model), and the closed slot
     row. No innerHTML rebuild, so the rail never loses its scroll position or its other 32
     images, and every visible change now runs through a CSS transition instead of snapping. */
  function selectModel(tierIndex, slotIndex, handle) {
    var product = byHandle[handle];
    if (!product) return;
    picks[tierIndex][slotIndex] = { h: handle, id: product.c[0].id };

    var pickerNode = root.querySelector(
      '.lpb__rail [data-tier="' + tierIndex + '"][data-slot="' + slotIndex + '"]'
    );
    pickerNode = pickerNode ? pickerNode.closest(".lpb__picker") : null;

    if (pickerNode) {
      pickerNode.querySelectorAll(".lpb__model").forEach(function (btn) {
        var isSel = btn.getAttribute("data-model") === handle;
        btn.classList.toggle("is-selected", isSel);
        btn.setAttribute("aria-pressed", String(isSel));
      });
      paintSelectedModelCard(picks[tierIndex][slotIndex]);

      var colorsBlock = pickerNode.querySelector(".lpb__colors");
      var newColorsHTML = colorStrip(product, picks[tierIndex][slotIndex].id, tierIndex, slotIndex);
      if (colorsBlock) {
        if (newColorsHTML) colorsBlock.outerHTML = newColorsHTML;
        else colorsBlock.remove();
      } else if (newColorsHTML) {
        var doneBtn = pickerNode.querySelector("[data-done]");
        if (doneBtn) doneBtn.insertAdjacentHTML("beforebegin", newColorsHTML);
      }
    }

    refreshSlot(tierIndex, slotIndex);
    updatePrices();
  }

  /* Switching the men's/women's tab only changes which models are browsable — it does not touch
     the current pick, so nothing else on the page needs to move. Same surgical pattern as
     selectModel(): rebuild only the rail (a genuinely different set of cards) and reset its
     scroll to the start, leave the tier cards, slot rows and everything else untouched. */
  function switchGender(tierIndex, slotIndex, gender) {
    if (gender === pickerGender || genders.indexOf(gender) === -1) return;
    pickerGender = gender;

    var pickerNode = root.querySelector(".lpb__picker");
    if (!pickerNode) return;

    pickerNode.querySelectorAll("[data-gender]").forEach(function (btn) {
      var on = btn.getAttribute("data-gender") === gender;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-selected", String(on));
    });

    var pick = picks[tierIndex][slotIndex];
    var pool = poolFor(gender);
    var rail = pickerNode.querySelector(".lpb__rail");
    if (rail) {
      var html = "";
      for (var n = 0; n < pool.length; n++) html += modelCard(pool[n], pick.h, pick.id, tierIndex, slotIndex);
      rail.innerHTML = html;
      rail.scrollTo({ left: 0, behavior: "auto" });
    }
    updatePager();
  }

  function refreshSlot(tierIndex, slotIndex) {
    var pick = picks[tierIndex][slotIndex];
    var product = byHandle[pick.h];
    var color = colorOf(pick);
    var node = root.querySelector('[data-open-picker][data-tier="' + tierIndex + '"][data-slot="' + slotIndex + '"]');
    if (!node) return;
    node.querySelector(".lpb__chosen").textContent = product.t;
    var name = colorLabel(product, color);
    var colorNode = node.querySelector(".lpb__color");
    colorNode.textContent = name;
    colorNode.hidden = !name;
    var thumb = node.querySelector("img.lpb__thumb");
    if (thumb && (color.img || product.img)) swapImage(thumb, color.img || product.img);
  }

  /* ---------- purchase ---------- */

  var infoScope = root.closest(".product__info-container") || document;
  var nativeForm = infoScope.querySelector('product-form form[action*="/cart/add"]') ||
    infoScope.querySelector('form[action*="/cart/add"]');
  var nativeButton = nativeForm ? nativeForm.querySelector('[name="add"]') : null;
  var routeRoot = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : "/";
  var purchaseButtons = nativeButton ? [nativeButton] : [];

  infoScope.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(function (button) {
    if (nativeForm && button.getAttribute("form") === nativeForm.getAttribute("id")) purchaseButtons.push(button);
  });

  function setBusy(value) {
    busy = value;
    root.classList.toggle("is-busy", value);
    root.setAttribute("aria-busy", String(value));
    root.querySelectorAll("button,input").forEach(function (control) { control.disabled = value; });
    updatePager();
    purchaseButtons.forEach(function (button) {
      if (!button) return;
      button.disabled = value;
      button.classList.toggle("loading", value);
      if (value) button.setAttribute("aria-busy", "true"); else button.removeAttribute("aria-busy");
    });
  }

  function showError(message) {
    var node = root.querySelector(".lpb__error");
    if (!node) return;
    node.textContent = message || T("לא הצלחנו להוסיף את השעונים לעגלה. בדקו את העגלה לפני ניסיון נוסף.", "ما قدرنا نضيف الساعات للسلة. شيّك على السلة قبل ما تجرّب كمان مرة.");
    node.hidden = false;
  }

  function showCart(json) {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.renderContents === "function" && json.sections && json.sections["cart-drawer"]) {
      try {
        drawer.classList.remove("is-empty");
        drawer.renderContents(json);
        if (typeof drawer.open === "function") drawer.open();
        return;
      } catch (e) { /* fall through to the cart page */ }
    }
    window.location.href = routeRoot + "cart";
  }

  function bundleItems() {
    var counts = {}, items = [];
    for (var n = 0; n < picks[selectedTier].length; n++) {
      var id = picks[selectedTier][n].id;
      counts[id] = (counts[id] || 0) + 1;
    }
    for (var key in counts) {
      if (Object.prototype.hasOwnProperty.call(counts, key)) items.push({ id: Number(key), quantity: counts[key] });
    }
    return items;
  }

  if (nativeForm && nativeButton) {
    var addBundle = function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      setBusy(true);

      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.setActiveElement === "function") {
        drawer.setActiveElement(event.currentTarget === nativeForm ? nativeButton : event.currentTarget);
      }
      var errorNode = root.querySelector(".lpb__error");
      if (errorNode) errorNode.hidden = true;

      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 30000);

      fetch(routeRoot + "cart/add.js", {
        method: "POST",
        signal: controller.signal,
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: bundleItems(),
          sections: "cart-drawer,cart-icon-bubble",
          sections_url: window.location.pathname
        })
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            var rejected = new Error(json.description || json.message || T("לא הצלחנו להוסיף את השעונים לעגלה.", "ما قدرنا نضيف الساعات للسلة."));
            rejected.shopifyResponse = true;
            throw rejected;
          }
          return json;
        });
      }).then(function (json) {
        window.clearTimeout(timeout);
        setBusy(false);
        showCart(json);
      }).catch(function (error) {
        window.clearTimeout(timeout);
        setBusy(false);
        showError(error.shopifyResponse ? error.message : null);
      });
    };
    nativeForm.addEventListener("submit", addBundle, true);
    purchaseButtons.slice(1).forEach(function (button) { button.addEventListener("click", addBundle, true); });
  }

  render();
})();
